import styled from 'styled-components'
import { rem } from 'polished'
import Sheet from 'components/utils/Sheet'
import TextButton from 'LuxKit/Button/TextButton'
import { STOP_TIMING_STICKY_HEADER_Z_INDEX } from '../components/stopTimingLayers'
import {
  CHAT_MAX_WIDTH,
  CHAT_MIN_WIDTH,
  LEFT_PANE_WIDTH_VAR,
  RIGHT_PANEL_MIN_WIDTH,
} from '../components/constants'

export {
  CHAT_DEFAULT_WIDTH,
  CHAT_MAX_WIDTH,
  CHAT_MIN_WIDTH,
  RIGHT_PANEL_MIN_WIDTH,
  LEFT_PANE_WIDTH_VAR,
  SHOW_ON_MAP_ZOOM,
  PLACE_SHOW_ON_MAP_ZOOM,
} from '../components/constants'

export const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`

export const ContentWrapper = styled.div`
  --right-panel-min-width: ${rem(RIGHT_PANEL_MIN_WIDTH)};

  display: grid;
  grid-template-columns: 1fr;
  flex: 1;
  min-height: 0;
`

export const MainContent = styled.div`
  display: grid;
  grid-template-columns:
    clamp(
      ${rem(CHAT_MIN_WIDTH)},
      var(${LEFT_PANE_WIDTH_VAR}),
      max(
        ${rem(CHAT_MIN_WIDTH)},
        min(${rem(CHAT_MAX_WIDTH)}, calc(100% - var(--right-panel-min-width)))
      )
    )
    0
    1fr;
  min-height: 0;
  height: 100%;
  overflow-x: auto;
`

export const ChatColumnLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  border-inline-end: 1px solid ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
`

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: ${rem(RIGHT_PANEL_MIN_WIDTH)};
  height: 100%;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  position: relative;
  overflow: hidden;
`

/** Fills the right panel; used to measure width without sharing the portal-target ref. */
export const RightPanelLayoutMeasure = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
`

export const FullHeightMapWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  height: 100%;
  overflow: hidden;
  position: relative;
`

export const MapArea = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  height: 100%;
  overflow: hidden;

  /* Force the ChatMapWidget to fill this container absolutely */
  & > .fill-container {
    position: absolute;
    top: 0;
    inset-inline: 0;
    bottom: 0;
    height: 100% !important;
  }
`

export const MapOverlayStack = styled.div`
  position: absolute;
  top: ${rem(12)};
  inset-inline: ${rem(12)};
  z-index: 6;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(8)};
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`

export const MapUpdatingIndicatorPill = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${rem(12)};
  padding: 0 ${rem(13)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border-radius: ${props => props.theme.borderRadius.round};
  box-shadow: ${props => props.theme.shadow.flat.small};
  height: ${rem(44)};
  pointer-events: none;
`

export const SearchThisAreaButton = styled(TextButton)`
  box-shadow: ${props => props.theme.shadow.flat.small};
`

export const RightPanelHeader = styled.div`
  position: relative;
  z-index: ${STOP_TIMING_STICKY_HEADER_Z_INDEX};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${rem(10)} ${rem(16)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
  flex-shrink: 0;

  && fieldset > div {
    grid-auto-columns: 1fr;
  }
`

export const RightPanelContent = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const EmptyStateWrapper = styled(Sheet)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const DayItineraryOverlay = styled.div`
  position: absolute;
  top: 0;
  inset-inline: 0;
  bottom: 0;
  z-index: 10;
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
`

export const InputWrapper = styled.div`
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  width: 100%;
  min-width: 0;
  padding-block-start: ${rem(16)};
  padding-inline: ${rem(16)};
  padding-block-end: ${rem(12)};

  &.has-context-bar {
    padding-block-start: 0;
  }

  &.flush-bottom {
    padding-block-end: 0;
  }
`

export const LandingPageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${rem(20)} 0;
  flex: 1;
  min-height: 0;
`
